import apiClient from "../../../../../services/ApiService";
import { getValidAccessToken } from "../../../../../utils/authRefresh";
import {
  SMS_OTP_SEND_PATH,
  SMS_OTP_VERIFY_REMINDER_PATH,
  type SmsOtpSendRequest,
  type SmsOtpSendSuccessResponse,
  type SmsOtpVerifyRequest,
  type SmsOtpVerifySuccessResponse,
} from "./smsOtpContract";

const getRequiredAccessToken = async (): Promise<string> => {
  const token = await getValidAccessToken();
  if (!token) {
    throw new Error("User not authenticated");
  }

  return token;
};

const getAuthHeaders = (token: string) => ({
  Authorization: `Bearer ${token}`,
});

export const toDigitsOnlyPhoneNumber = (value: string): string => {
  return value.replace(/\D/g, "");
};

export const sendReminderSmsVerificationCode = async (input: SmsOtpSendRequest): Promise<SmsOtpSendSuccessResponse> => {
  const token = await getRequiredAccessToken();

  const response = await apiClient.post<SmsOtpSendSuccessResponse>(SMS_OTP_SEND_PATH, input, {
    headers: getAuthHeaders(token),
  });

  return response.data;
};

export const verifyReminderSmsVerificationCode = async (
  input: SmsOtpVerifyRequest
): Promise<SmsOtpVerifySuccessResponse> => {
  const token = await getRequiredAccessToken();

  const response = await apiClient.post<SmsOtpVerifySuccessResponse>(SMS_OTP_VERIFY_REMINDER_PATH, input, {
    headers: getAuthHeaders(token),
  });

  return response.data;
};
